export const GAMEPLAY_CONNECTION_GRACE_MS = 1000
export const GAMEPLAY_ACTION_WATCHDOG_MS = 2500
export const GAMEPLAY_HEARTBEAT_INTERVAL_MS = 5000
export const GAMEPLAY_STATE_STALE_MS = 1_000_000
export const GAMEPLAY_DECK_INVARIANT_DEBOUNCE_MS = 3000
export const GAMEPLAY_EXPECTED_HAND_SIZE = 5
